import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNullOrUndefined } from 'is-what';

import { LoginService } from '../pages/login/login.service';

@Injectable()
export class AdminAuthguardService implements CanActivate {
  constructor(private router: Router, private loginsvc: LoginService) {}

  getDealerInfo(qparams: Params): Observable<any> {
    const dealerInfo = this.loginsvc.getDealerInfo();
    if (dealerInfo) {
      return of(dealerInfo);
    } else if (qparams && qparams.xString) {
      return this.loginsvc.xstringLogin(qparams.xString).pipe(
        map(data => {
          return data.IsSuccess ? this.loginsvc.getDealerInfo() : null;
        })
      );
    } else {
      return of(null);
    }
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const qparams = Object.assign({}, next.queryParams);

    return this.getDealerInfo(qparams).pipe(
      map(dealerInfo => {
        if (isNullOrUndefined(dealerInfo)) {
          qparams.next = state.url;
          this.router.navigate([environment.loginRoute], {
            queryParams: qparams
          });
          return false;
        } else if (parseInt(dealerInfo.empType, 10) === -1) {
          return true;
        } else {
          this.router.navigate([environment.accessDeniedRoute], {
            queryParams: qparams
          });
          return false;
        }
      })
    );
  }
}
